import { useSelector } from "react-redux";
import store from "../storeWire";
import { getProfileAccountInformation, getCountryList, getJobFunctionList,fetchAllCarrierData, setAllCarrierData} from "../store/slice/model/Profile";
import ProfileRepository from "src/repository/ProfileRepository";

export function profileStore() {
    const profile_user_information = useSelector((state) => state.entities.model_Profile.userInformation)
    const profile_account_information = useSelector((state) => state.entities.model_Profile.accountInformation)
    const shipping_addresses = useSelector((state) => state.entities.model_Profile.accountInformation?.shipTo)
    const billing_addresses = useSelector((state) => state.entities.model_Profile.accountInformation?.billTo)
    const all_carriers = useSelector((state) => state.entities.model_Profile.allCarriers)
    const countryList = useSelector((state) => state.entities.model_Profile.countryList)
    const jobFunctionList = useSelector((state) => state.entities.model_Profile.jobFunctionList)

    let data = {
        profile_user_information,
        profile_account_information,
        shipping_addresses,
        billing_addresses,
        all_carriers,
        countryList,
        jobFunctionList,
    };
    let fetch = {
        // Profile
        get_profile_account_information: async () => { 
            return await store.dispatch(getProfileAccountInformation())
        },
        get_profile_job_function_list: async () => {
            return await store.dispatch(getJobFunctionList())
        },
        get_country_list: async () => {
            return await store.dispatch(getCountryList())
        },
        get_state_list: async (params) => {
            return await new ProfileRepository().getStateList(params);
        },
        fetch_all_carrier_data: async (params) => {
            return await store.dispatch(fetchAllCarrierData(params))
        },
    };
    let set = {
        set_contact_data: async (data) => {
            return await new ProfileRepository().setContactData(data)
        },
        set_account_address_default: async (data) => {
            return await new ProfileRepository().setAccountAddressDefault(data)
        },
        add_profile_address: async (params) => {
            return await new ProfileRepository().addProfileAddress(params);
        },
        validate_profile_address: async (params) => {
            return await new ProfileRepository().validateProfileAddress(params);
        },
        edit_profile_invoice_address: async (params) => {
            return await new ProfileRepository().editProfileInvoiceAddress(params);
        },
        set_account_link_data: async (data) => {
            return await new ProfileRepository().setAccountLinkData(data)
        },
        check_valid_account: async (params) => {
            return await new ProfileRepository().checkValidAccount(params)
        },
    };
    return [data, fetch, set]
}